/**
 * Recruiting User Settings Form
 * User preferences for recruiting module, including data export/import
 */
import { useTranslation } from 'react-i18next';
import { ExportImportSection } from '../../../shared/components/common/ExportImportSection';

interface RecruitingUserSettingsFormProps {
  onSuccess?: () => void;
}

export function RecruitingUserSettingsForm({ onSuccess: _onSuccess }: RecruitingUserSettingsFormProps) {
  const { t } = useTranslation(['recruiting', 'common']);

  const formatEntityCounts = (counts: Record<string, number>): string => {
    const parts: string[] = [];
    if (counts.pipelines) parts.push(`${counts.pipelines} ${t('recruiting:exportImport.pipelines')}`);
    if (counts.job_postings) parts.push(`${counts.job_postings} ${t('recruiting:exportImport.jobPostings')}`);
    if (counts.candidates) parts.push(`${counts.candidates} ${t('recruiting:exportImport.candidates')}`);
    if (counts.applications) parts.push(`${counts.applications} ${t('recruiting:exportImport.applications')}`);
    if (counts.interviews) parts.push(`${counts.interviews} ${t('recruiting:exportImport.interviews')}`);
    return parts.join(', ');
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        {t('recruiting:settings.description', 'Manage your recruiting module data and preferences.')}
      </p>
      <ExportImportSection
        moduleName="recruiting"
        adminModuleName="recruiting"
        i18nNamespace="recruiting"
        invalidateKeys={[['pipelines'], ['jobs'], ['candidates'], ['applications']]}
        formatEntityCounts={formatEntityCounts}
      />
    </div>
  );
}
